// src/components/ProjectCard.js
import React from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt, FaChevronRight } from "react-icons/fa";
import "./ProjectCard.css";

const ProjectCard = ({ id, imgsrc, date, title, text, view }) => {
  const preview = text.length > 120 ? text.slice(0, 120).trimEnd() + "…" : text;

  return (
    <article className="project-card card">
      {/* Image */}
      <div className="project-card__img-wrap">
        <img
          src={imgsrc || `https://picsum.photos/seed/${encodeURIComponent(title)}/600/360`}
          alt={title}
          loading="lazy"
        />
        {view && view !== "#" && (
          <a
            href={view}
            target="_blank"
            rel="noreferrer"
            className="project-card__img-overlay"
            aria-label={`View ${title}`}
          >
            <FaExternalLinkAlt size={20} />
          </a>
        )}
      </div>

      {/* Body */}
      <div className="project-card__body">
        <div className="project-card__meta">
          <span className="badge badge-accent">{date}</span>
        </div>

        <h3 className="project-card__title">{title}</h3>

        <p className="project-card__desc">
          {preview}
        </p>

        <div className="project-card__footer">
          <Link to={`/projects/${id}`} className="btn btn-ghost project-card__toggle">
            Read more <FaChevronRight size={11} />
          </Link>

          {view && view !== "#" && (
            <a
              href={view}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary project-card__cta"
            >
              View <FaExternalLinkAlt size={11} />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
